import React from "react";

import { useIntl } from "react-intl";

import { EntityTypesSupportingRoutes, Route } from "@mapmycustomers/shared/types/entity";

import noRoutesSvg from "@app/assets/list/preview/no-routes.svg";
import NoData from "@app/component/preview/components/NoData";

import RouteItem from "./RouteItem";

interface Props {
  entityType: EntityTypesSupportingRoutes;
  onRemoveRoute?: (route: Route) => void;
  removeLoadingIds?: Route["id"][];
  routes: Route[];
}

const EditRoutesPanel: React.FC<Props> = ({
  entityType,
  onRemoveRoute,
  removeLoadingIds,
  routes,
}) => {
  const intl = useIntl();

  return (
    <>
      {routes.length === 0 ? (
        <NoData
          imageSrc={noRoutesSvg}
          text={intl.formatMessage({
            id: "recordPane.routes.noData",
            defaultMessage: "Add this record to a route",
            description: "No data text in an associated routes section in Edit pane",
          })}
        />
      ) : (
        routes.map((route) => (
          <RouteItem
            entityType={entityType}
            key={route.id}
            onRemove={onRemoveRoute}
            removeLoading={removeLoadingIds?.includes(route.id)}
            route={route}
          />
        ))
      )}
    </>
  );
};

export default EditRoutesPanel;
